const initialState = {
    listOfTagCategories: [],
    isGettingListOfTagCategories: false,
    isAddingTagCategory: false,
};

export default initialState;
